import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./secondary-button.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./secondary-button.component.scss?ngResource";
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from "@angular/core";
let SecondaryButtonComponent = class SecondaryButtonComponent {
    displayText;
    clickCallBack = new EventEmitter();
    disabled;
    constructor() {
    }
    ngOnInit() {
        this.displayText = this.displayText.toLowerCase();
    }
    onclick($event) {
        this.clickCallBack.emit($event);
    }
    static ctorParameters = () => [];
    static propDecorators = {
        displayText: [{ type: Input }],
        clickCallBack: [{ type: Output }],
        disabled: [{ type: Input }]
    };
};
SecondaryButtonComponent = __decorate([
    Component({
        selector: "app-secondary-button[displayText]",
        template: __NG_CLI_RESOURCE__0,
        changeDetection: ChangeDetectionStrategy.OnPush,
        styles: [__NG_CLI_RESOURCE__1]
    })
], SecondaryButtonComponent);
export { SecondaryButtonComponent };
